import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../App';
import { RefreshCw, CheckCircle, XCircle } from 'lucide-react';

export default function OAuthCallback() {
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('Completing authorisation...');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    const error = params.get('error');

    if (error) {
      setStatus('error');
      setMessage(`Authorisation denied: ${params.get('error_description') || error}`);
      return;
    }

    if (!code || !state) {
      setStatus('error');
      setMessage('Missing authorisation code or state. Please try again.');
      return;
    }

    // Determine provider from state (stored in localStorage or try both)
    const provider = localStorage.getItem(`oauth_provider_${state}`) || 'xero';
    const token = localStorage.getItem('token');

    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    axios.post(`${API}/integrations/oauth/callback`, { code, state, provider }, { headers })
      .then(res => {
        setStatus('success');
        setMessage(res.data.message || 'Successfully connected!');
        setTimeout(() => window.close(), 2000);
      })
      .catch(err => {
        setStatus('error');
        setMessage(err.response?.data?.detail || 'Failed to complete authorisation. Please try again.');
      });
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="bg-white rounded-xl shadow-sm border p-8 max-w-md w-full text-center">
        {status === 'processing' && (
          <>
            <RefreshCw className="h-10 w-10 mx-auto mb-4 animate-spin text-teal-600" />
            <h2 className="text-lg font-semibold text-slate-900 mb-2">Connecting...</h2>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle className="h-10 w-10 mx-auto mb-4 text-green-600" />
            <h2 className="text-lg font-semibold text-green-700 mb-2">Connected</h2>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle className="h-10 w-10 mx-auto mb-4 text-red-500" />
            <h2 className="text-lg font-semibold text-red-600 mb-2">Connection Failed</h2>
          </>
        )}
        <p className="text-sm text-slate-600">{message}</p>
        {status !== 'processing' && (
          <button onClick={() => window.close()} className="mt-4 text-sm text-teal-600 hover:underline">
            Close this window
          </button>
        )}
      </div>
    </div>
  );
}
